/**
 * Check buttons list component script
 */
export const PhoneEntry = (function () {
    var init = function () {
        $('.phone-entry .dropdown-item').on('click', function(){ 
          
            $(this).closest('.dropdown').find('.dropdown-toggle').html($(this).html());
            //change a hidden input also for the prefix
            $(this).closest('.phone-entry').find('.prefix').val($(this).html());
          
        });
    };


  
    return {
      init: init,
    };
  })();
  